export default __webpack_public_path__ + "static/media/money_variable_detail.772b27aa.svg";